import dayjs from 'dayjs';

export function calculateShipments(currentDate, shippingFrequency, endDate) {
  const automationEndDate = dayjs(endDate);

  // Calculate total number of days between the dates
  const totalDays = automationEndDate.diff(currentDate, 'day');

  // Calculate the number of shipments
  return Math.floor(totalDays / shippingFrequency);
}

/**
 *  function to get variant details
 */
export const getVariantDetails = (id, variants, allOptions) => {
  if (variants?.[0]?.option1 === 'Default Title' || variants?.length === 1) {
    return variants[0];
  } else {
    const selectedVariant = variants?.find((product) => {
      if (product?.option1 && product?.option2 && product?.option3) {
        return (
          product?.option1 === allOptions?.[id]?.option1 &&
          product?.option2 === allOptions?.[id]?.option2 &&
          product?.option3 === allOptions?.[id]?.option3
        );
      } else if (product?.option1 && product?.option2) {
        return product?.option1 === allOptions?.[id]?.option1 && product?.option2 === allOptions?.[id]?.option2;
      } else if (product?.option1 === allOptions?.[id]?.option1) {
        return product?.option1 === allOptions?.[id]?.option1;
      } else {
        return null;
      }
    });
    return selectedVariant;
  }
};

export const getorderDetails = (selectedProductsForOrder, allOptions, quantities) => {
  return selectedProductsForOrder.map((product) => {
    const variant = getVariantDetails(product.id, product.variants, allOptions);
    const variantDetailObject = {};
    if (
      product?.variants?.[0] &&
      product?.variants?.[0]?.option1 !== 'Default Title' &&
      Object.keys(allOptions).length > 0
    ) {
      if (product?.options?.length > 0 && allOptions[product.id]) {
        product.options.forEach((option, index) => {
          variantDetailObject[option.name] = allOptions[product.id][`option${index + 1}`];
        });
      }
    }
    return {
      variantId: variant?.variantId || product?.id,
      productId: product?.id,
      productDetails: {
        productImage: product?.image,
        productName: product?.name,
        productPrice: variant?.price,
        variantDetail: variantDetailObject,
      },
      quantity: quantities[product?.id],
    };
  });
};

export const checkIfDisabled = (selectedProducts, allOptions) => {
  const disabledArray = selectedProducts.map((product) => {
    if (product.options?.[0]?.options?.[0] === 'Default Title') {
      return false;
    } else if (product?.options?.length === 3) {
      return !allOptions[product.id]?.option1 || !allOptions[product.id]?.option2 || !allOptions[product.id]?.option3;
    } else if (product?.options?.length === 2) {
      return !allOptions[product.id]?.option1 || !allOptions[product.id]?.option2;
    } else if (product?.options?.length === 1) {
      return !allOptions[product.id]?.option1;
    } else {
      return false;
    }
  });
  return !disabledArray.every((ele) => ele === false);
};
